<template>
  <div class="w-full flex flex-col gap-2">
    <form @submit.prevent="updateGroup" class="w-full">


      <div class="w-full pb-3">
        <div class="w-full">
          <label form="name" class="">{{ $t('name')}}</label>
          <b-select v-model="selectedState"
            placeholder="Seleccione un estado" expanded>
              <option
                  v-for="option in ungroupedStates"
                  :value="option.id"
                  :key="'ungroupedStates_'+option.id"
              >
                  {{ option.name }}
              </option>
          </b-select>
        </div>
      </div>

      <div v-if="selectedState && weightingCriteria !== 'default'"
        class="w-full mb-3">
        <label for="weight">{{ $t('weight') }}</label>
        <b-numberinput v-model="selectedState.weight"
          controls-position="compact"
          min="0"
          max="100"
          :disabled="weightingCriteria !== 'custom'"
          expanded
          icon-pack="fas"></b-numberinput>
      </div>

      <div v-if="showActions" class="w-full flex flex-row justify-between gap-x-2 pb-3 mt-8">
        <button type="button"
          class="btn btn-default"
          @click="() => { $emit('epc-group-status-form-close') }">
          Cancelar
        </button>

        <button
          class="btn btn-blue"
          nativeType="submit"
        >
          {{ $t( form.id != null ? 'edit' : 'add' ) }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'LayerGroupStatusLinkForm',
  props: {
    ungroupedStates: {
      type: Array,
      default: () => []
    },
    weightingCriteria: {
      type: String,
      default: null
    },
    showActions: {
      type: Boolean,
      default: true
    },
    colorpickerInline: { type: Boolean, default: false } // Indica si el selector de color se mostrara en linea o haciendo click en un input
  },
  data() {
    return {

      formatColor: 'hex',

      selectedState: null,
      weight: null,
    };
  },
  methods: {
    formatter (color) {
      return color.toString(this.formatColor)
    },

    async updateGroup() {
      // this.$toast.open({
      //   message: msg,
      //   type: 'is-danger',
      //   position: 'is-top-right'
      // })
      const e = this.getData();
      this.$emit('epc-group-link-state', s)

      this.reset()
    },

    reset() {

      this.selectedState = null;

      this.processingData = false
    },

    getData() {
      let state = this.ungroupedStates.find(s => s.id === this.selectedState);
      return {
        id: state.id,
        group_id: state.group_id,
        code: state.code,
        name: state.name,
        weight: this.weight,
        color: state.color,
        is_completion: state.is_completion,
        type: state.type,
        permissions: state.permissions,
      };
    }
  }
};
</script>
